import { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { spacing, sizing, display, flexbox, } from '@material-ui/system';
import styled from 'styled-components';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { DatePicker, toISOString } from "../../components/date_picker";

const Box = styled.div`${spacing}${sizing}${display}${flexbox}`;

import { axiosInstance } from "../../utils/axiosApi";
import { BaseContainer } from "../../components/container";
import Loading from "../../components/loading";
import SuccessDialog from "../../components/dialogs/success_dialog";
import ErrorDialog from "../../components/dialogs/error_dialog";
import {validateName, validateEmail} from '../../components/text_input'

const useStyles = makeStyles((theme) => ({
    heading: {
        fontWeight: 600,
        fontSize: theme.typography.fontSize * 1.5,
        marginBottom: theme.spacing(2)
    },
    share_text: {
        marginBottom: theme.spacing(2)
    },
    secondary_text: {
        fontSize: '0.8rem',
        lineHeight: '0.9rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1)
    },
    selector: {
        minWidth: 300,
    },
    select: {
        '&:focus': {
            backgroundColor: theme.palette.common.white
        }
    }
}))

const TestResetEMRUser = (props) => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState('')
    const [showSuccess, setShowSuccess] = useState(false)
    const [error, setError] = useState('')
    const [showError, setShowError] = useState(false)
    const [name, setName] = useState('')

    const classes = useStyles();

    function handleError (error, defaultMsg) {
        let msg = defaultMsg
        if (error.response?.data?.error) {
            console.error(error)
            msg = error.response.data.error
        }
        setError(msg)
        setShowError(true)
        setLoading(false)
    }

    const resetEMRUser = () => {
        setLoading(true)
        axiosInstance.post('/test/reset-emr-user/', {
            name,
        }).then(() => {
            setLoading(false)
            setSuccess('User reset successfully')
            setShowSuccess(true)
        }).catch(err => {
            handleError(err, 'Error resetting user.')
        })
    }

    const handleChange = (e) => {
        setName(e.target.value)
    }

    return (
        <BaseContainer {...props}>
            {loading && <Loading loading={loading} />}
            <Typography variant="h5" className={classes.heading}>
                Reset EMR User
            </Typography>
            <TextField
                id="full_name"
                name="full_name"
                label="Full Name"
                placeholder="Full Name"
                fullWidth
                margin="normal"
                value={name}
                onChange={handleChange}
            />
            <Box width="100%" mt={2} mb={2}>
                <Button fullWidth variant='contained' color='primary' onClick={() => resetEMRUser()}>
                    Reset EMR User
                </Button>
            </Box>
            <SuccessDialog open={showSuccess} setOpen={setShowSuccess} success={success}/>
            <ErrorDialog open={showError} setOpen={setShowError} error={error}/>
        </BaseContainer>
    )
}
export default TestResetEMRUser;
